module.exports = __webpack_public_path__ + "img/noteicon.9aa4dbbe.svg";